import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
	OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
// SERVICES
import { AlertService } from '@services/notification/alert.service';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { AuthenticationConfigurationService } from '@services/authentication/authentication-configuration.service';
import { System } from '@models/System';
import { getSystem } from '@utils/system';
// TODO : TAG GTM
declare var dataLayer: any;
@Component({
	selector: 'ui-header',
	templateUrl: './header.html',
	styleUrls: ['./header.scss'],
	encapsulation: ViewEncapsulation.None,
	host: {
		class: 'ui-header',
	},
})
export class UIHeader implements OnInit, OnDestroy {
	subscription = new Subscription();
	username = '';
	rol = '';
	system!: System;
	private isOpen = false;
	@Output()
	toggle = new EventEmitter();
	@Input()
	get open() {
		return this.isOpen;
	}

	set open(value: boolean) {
		this.isOpen = value;
	}

	showOption: boolean = true;
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		private alertService: AlertService,
		private authenticationService: AuthenticationService,
		private authConfigService: AuthenticationConfigurationService
	) {
		this.getUser();
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
		const email = sessionStorage.getItem('email');
		this.showOption =
			email === 'usuarioprueba@hachette.com.mx' ||
			email === 'secundariaoficial@hachette.com.mx'
      || email === 'trayectorias@mail.com'
				? false
				: true;
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	getUser() {
		this.subscription.add(
			this.authConfigService.currentUser.subscribe((x) => {
				if (x) {
					this.username = x.fullName || '';
					this.rol = x.rol || '';
					this.system = getSystem(x.systemId);
				}
			})
		);
	}

	toggleMenu() {
		if (!this.open) {
			this.eventGTM();
		}
		this.toggle.emit();
	}

	async logout() {
		if (
			await this.alertService.showConfirmationAction({ text: '¿Deseas cerrar sesión?' })
		) {
			// En cualquier otro componente o servicio donde necesites acceder al valor
			const tiempoInicioSesionString = sessionStorage.getItem('tiempoInicioSesion');

			if (tiempoInicioSesionString !== null) {
				const tiempoInicioSesion = JSON.parse(tiempoInicioSesionString);
				console.log(tiempoInicioSesion);

				const tiempoFinSesion = new Date();
				const tiempoInicioMs = new Date(tiempoInicioSesion).getTime();
				const tiempoFinMs = tiempoFinSesion.getTime();

				const duracionSesionMs = tiempoFinMs - tiempoInicioMs;

				// Convierte la duración a minutos o horas, según lo necesites
				const duracionSesionEnMinutos = Math.floor(duracionSesionMs / (1000 * 60));
				const duracionSesionEnHoras = Math.floor(duracionSesionMs / (1000 * 60 * 60));

				console.log(
					`El usuario estuvo logueado durante ${duracionSesionEnMinutos} minutos o ${duracionSesionEnHoras} horas.`
				);

				// Haz algo con el valor almacenado
			} else {
				// La sesión no está activa o el valor no está presente en SessionStorage
			}

			this.subscription.add(
				this.authenticationService
					.logout()
					.subscribe((x) => this.alertService.showSmallSuccess('Sesión finalizada'))
			);
		}
	}

	eventGTM() {
		dataLayer.push({
			event: 'menu_view',
			account_type: this.rol,
			method: 'email',
			content_group: 'Home',
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}
}
